import { AnnotationType } from 'components/AnnotationProject/types'
import { CSSProperties } from 'styled-components'
import { Annotation } from './Annotation'
const ymove = 6
const Labels = {
  konv: {
    liege: (
      <>
        <span>1,65m</span>
        <br />
        Länge der eingestreuten Liegefläche
      </>
    ),
    eat: (
      <>
        <span>65cm</span>
        <br />
        Platz am Trog
      </>
    ),
    fress: (
      <>
        <span>0,65m x 2,9m</span>
        <br />
        Fressplatz
      </>
    ),
    box: (
      <>
        <span>1,1m x 2,3m</span>
        <br />
        Liegebox (wandständig)
      </>
    ),
  },
  bio: {
    eat: (
      <>
        <span>65cm</span>
        <br />
        Platz am Trog
      </>
    ),
    lauf: (
      <>
        <span>
          10m<sup>2</sup>
        </span>
        <br />
        Laufhoffläche pro Tier
      </>
    ),
    fress: (
      <>
        <span>0,65m x 2,9m</span>
        <br />
        Fressplatz
      </>
    ),
    liege: (
      <>
        <span>1,65m</span>
        <br />
        Länge der Liegefläche
      </>
    ),
    box: (
      <>
        <span>1,1m x 2,3m</span>
        <br />
        Liegebox (wandständig)
      </>
    ),
  },
  eu: {
    eat: (
      <>
        <span>60cm</span>
        <br />
        Platz am Trog
      </>
    ),
    box: (
      <>
        <span>1,15m x 2,3m</span>
        <br />
        Liegebox (wandständig)
      </>
    ),
  },
}

export const getAnnotations_Kuh = (
  colorMode: 'light' | 'dark' = 'light',
  width: number,
  standards: 'eu' | 'konventionell' | 'bio'
) => {
  const connectorStyle =
    colorMode === 'light'
      ? { stroke: '#000', strokeWidth: 0.5 }
      : { stroke: '#fff', strokeWidth: 0.5 }
  const connector: {
    type: 'straight' | 'curved'
    style: CSSProperties
    offset: number
  } = { type: 'straight', style: connectorStyle, offset: 0 }
  const K_Annotations_Konventionell: AnnotationType[] = [
    {
      left: 20,
      top: 61 + ymove,
      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.konv.eat}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 42,
      top: 50 + ymove,
      anchor: 'bottom',
      distance: 80,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.konv.fress}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 56,
      top: 36 + ymove,
      anchor: 'bottom',
      distance: 120,
      content: (
        <Annotation
          colorMode={colorMode}
          align='left'
          style={{ minWidth: 120 }}
        >
          {Labels.konv.liege}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 78,
      top: 30 + ymove,

      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          style={{ minWidth: 120 }}
          align='left'
        >
          {Labels.konv.box}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const K_Annotations_Konventionell_Medium: AnnotationType[] = [
    {
      left: 20,
      top: 55 + ymove,
      anchor: 'bottom',

      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.konv.eat}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 42,
      top: 46 + ymove,
      anchor: 'bottom',
      distance: 80,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.konv.fress}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 66,
      top: 30 + ymove,
      anchor: 'bottom',
      distance: 120,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.konv.liege}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 78,
      top: 36 + ymove,

      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          style={{ minWidth: 120 }}
          align='left'
        >
          {Labels.konv.box}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const K_Annotations_Konventionell_Small: AnnotationType[] = [
    {
      left: 10,
      top: 54 + ymove,
      anchor: 'bottom',

      content: (
        <Annotation
          colorMode={colorMode}
          align='left'
          style={{ minWidth: 80, maxWidth: 80 }}
        >
          {Labels.konv.eat}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 38,
      top: 47 + ymove,
      anchor: 'bottom',
      distance: 80,
      content: (
        <Annotation colorMode={colorMode} align='left' style={{ maxWidth: 80 }}>
          {Labels.konv.fress}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 66,
      top: 34 + ymove,
      anchor: 'bottom',
      distance: 140,
      content: (
        <Annotation
          colorMode={colorMode}
          align='left'
          style={{ minWidth: 120 }}
        >
          {Labels.konv.liege}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 72,
      top: 36 + ymove,

      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          style={{ minWidth: 120 }}
          align='left'
        >
          {Labels.konv.box}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]

  const K_Annotations_Bio: AnnotationType[] = [
    {
      left: 20,
      top: 61 + ymove,
      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.bio.eat}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 40,
      top: 61 + ymove,
      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.bio.lauf}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 42,
      top: 40 + ymove,
      anchor: 'top',
      distance: 100,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.bio.fress}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 56,
      top: 36 + ymove,
      anchor: 'bottom',
      distance: 180,
      content: (
        <Annotation
          colorMode={colorMode}
          align='left'
          style={{ minWidth: 120 }}
        >
          {Labels.bio.liege}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 78,
      top: 30 + ymove,

      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          style={{ minWidth: 120 }}
          align='left'
        >
          {Labels.bio.box}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const K_Annotations_Bio_Medium: AnnotationType[] = [
    {
      left: 20,
      top: 55 + ymove,
      anchor: 'bottom',

      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.bio.eat}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 40,
      top: 55 + ymove,
      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.bio.lauf}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 42,
      top: 35 + ymove,
      anchor: 'top',
      distance: 100,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.bio.fress}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 66,
      top: 30 + ymove,
      anchor: 'bottom',
      distance: 200,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.bio.liege}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 78,
      top: 36 + ymove,

      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          style={{ minWidth: 120 }}
          align='left'
        >
          {Labels.bio.box}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const K_Annotations_Bio_Small: AnnotationType[] = [
    {
      left: 10,
      top: 54 + ymove,
      anchor: 'bottom',

      content: (
        <Annotation
          colorMode={colorMode}
          align='left'
          style={{ minWidth: 120 }}
        >
          {Labels.bio.eat}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 24,
      top: 51 + ymove,
      anchor: 'bottom',
      distance: 100,
      content: (
        <Annotation
          colorMode={colorMode}
          align='left'
          style={{ minWidth: 120 }}
        >
          {Labels.bio.fress}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 66,
      top: 34 + ymove,
      anchor: 'bottom',
      distance: 230,
      content: (
        <Annotation
          colorMode={colorMode}
          align='left'
          style={{ maxWidth: 120 }}
        >
          {Labels.bio.liege}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 73,
      top: 36 + ymove,

      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          style={{ minWidth: 120 }}
          align='left'
        >
          {Labels.bio.box}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  //
  const K_Annotations_EU: AnnotationType[] = [
    {
      left: 40,
      top: 56 + ymove,
      anchor: 'bottom',
      distance: 50,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.eu.eat}
        </Annotation>
      ),
      connect: true,
      connector,
    },

    {
      left: 68,
      top: 38 + ymove,
      distance: 50,
      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          style={{ minWidth: 120 }}
          align='left'
        >
          {Labels.eu.box}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const K_Annotations_EU_Medium: AnnotationType[] = [
    {
      left: 40,
      top: 48 + ymove,
      anchor: 'bottom',
      distance: 50,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.eu.eat}
        </Annotation>
      ),
      connect: true,
      connector,
    },

    {
      left: 68,
      top: 36 + ymove,
      distance: 50,
      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          style={{ minWidth: 120 }}
          align='left'
        >
          {Labels.eu.box}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const K_Annotations_EU_Small: AnnotationType[] = [
    {
      left: 40,
      top: 43 + ymove,
      anchor: 'bottom',
      distance: 50,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.eu.eat}
        </Annotation>
      ),
      connect: true,
      connector,
    },

    {
      left: 68,
      top: 38 + ymove,
      distance: 50,
      anchor: 'bottom',
      content: (
        <Annotation
          colorMode={colorMode}
          style={{ minWidth: 120 }}
          align='left'
        >
          {Labels.eu.box}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]

  if (standards === 'eu')
    return width > 831
      ? K_Annotations_EU
      : width > 542
      ? K_Annotations_EU_Medium
      : K_Annotations_EU_Small
  if (standards === 'bio')
    return width > 831
      ? K_Annotations_Bio
      : width > 542
      ? K_Annotations_Bio_Medium
      : K_Annotations_Bio_Small
  if (standards === 'konventionell')
    return width > 831
      ? K_Annotations_Konventionell
      : width > 542
      ? K_Annotations_Konventionell_Medium
      : K_Annotations_Konventionell_Small
}
